<template>
    <div class="flex flex-wrap">
        <div v-if="format === 'complete'" class="flex self-center">
            <span v-if="stop" class="digit">-</span>
            <div v-if="showDays" class="flex content-column mx-1">
                <p class="digit">
                    <template >{{ days | two_digits }}</template>
                </p>
                <p class="text">Dias</p>
            </div>
            <div class="flex content-column mx-1">
                <p class="digit">
                    <template >{{ hours | two_digits }}</template>
                </p>
                <p class="text">Horas</p>
            </div>
            <div class="flex content-column mx-1">
                <p class="digit">
                    <template >{{ minutes | two_digits }}</template>
                </p>
                <p class="text">Minutos</p>
            </div>
            <div v-if="showSeconds" class="flex content-column mx-1">
                <p class="digit">
                    <template >{{ seconds | two_digits }}</template>
                </p>
                <p class="text">Segundos</p>
            </div>
        </div>
        <div class="flex justify-center w-full">
            <span v-if="stop" class="digit">-</span>
            <span v-if="showDays" class="digit">
                <template >{{ days | two_digits }}</template>d:
            </span>
            <span class="digit">
                <template >{{ hours | two_digits }}</template>h:
            </span>
            <span class="digit">
                <template >{{ minutes | two_digits }}</template>m
            </span>
            <span v-if="showSeconds" class="digit">
                <template >{{ seconds | two_digits }}</template>s
            </span>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Countdown",
        filters: {
            two_digits: function (value) {
                if (value.toString().length <= 1) {
                    return "0" + value.toString();
                }
                return value.toString();
            }
        },
        props: {
            date: {
                type: [Date, Object]
            },
            dateFechamento: {
                type: [Date, Object]
            },
            dateRegister: {
                type: [Date, Object]
            },
            format: {
                type: String,
                default: 'complete',
                validator: function (value) {
                    return ['complete', 'digital'].indexOf(value) !== -1
                }
            },
            showDays: {
                type: Boolean,
            },
            showSeconds: {
                type: Boolean
            }
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                end: new Date()
            }
        },
        computed: {
            stop() {
                return this.end < this.now && Math.trunc((this.end - this.now))/60 <-1;
            },

            seconds() {
                let seconds = (this.end - this.now) % 60
                return seconds >= 0 ? seconds : seconds*-1
            },

            minutes() {
                let minutes = Math.trunc((this.end - this.now) / 60) % 60
                return minutes >= 0 ? minutes : minutes*-1
            },

            hours() {
                let hours = this.showDays ? Math.trunc((this.end - this.now) / 60 / 60) % 24 : Math.trunc((this.end - this.now) / 60 / 60)
                return hours >= 0 ? hours : hours*-1
            },

            days() {
                let days = Math.trunc((this.end - this.now) / 60 / 60 / 24)
                return days >= 0 ? days : days*-1
            }
        },
        created() {
            
            if (this.dateFechamento){
                this.now = Math.trunc(Date.parse(this.dateFechamento) / 1000)
                if (this.dateRegister){
                    this.end = Math.trunc(Date.parse(this.dateRegister) / 1000)
                }
            }else {
                this.end = Math.trunc(Date.parse(this.date) / 1000)
            }
        },
        mounted() {
            if (!this.stop) {
                window.setInterval(() => {
                    this.dateFechamento ?
                    this.now = Math.trunc(Date.parse(this.dateFechamento) / 1000) :
                    this.now = Math.trunc((new Date()).getTime() / 1000)
                }, 1000)
            }
        },

    }

</script>
<style>

    .text {
        color: #2c418c;
        font-size: 1em;
        font-weight: 100;
        margin-top: 2px;
        margin-bottom: 2px;
        text-align: center;
    }

    .digit {
        color: #000000;
        font-size: 1.2em;
        text-align: center;
    }
</style>
